import actionType from "./GISIPWPL01ActionType";

// レスポンスState定義
const infoState = {
    isFetching: false,
    isError: false,
    data: {},
    err_type: "",
    err_detail: []
};

/**
 * 実習計画案件データ取得
 * @param {*} state
 * @param {*} action
 */
export const getWorkingPlanInfoList = (state = infoState, action) => {
    switch (action.type) {
        case actionType.GET_WORK_PLAN_INFO_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionType.GET_WORK_PLAN_INFO_LIST_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionType.GET_WORK_PLAN_INFO_LIST_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionType.GET_WORK_PLAN_INFO_LIST_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                data: {},
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
